import React from 'react';
import styled from '@emotion/styled';
import { rem } from 'polished';
import { colors, mixins } from '../../core/styles/theme/default';

const StyledStatusLegend = styled.div`
  display: flex;
  padding-bottom: ${rem(18)};
  margin-top: ${rem(34)};
  background: linear-gradient(
      90deg,
      #320d03 0%,
      #7e0d03 16.67%,
      #ef6706 37.7%,
      #ffaf0a 58.94%,
      #ffff4b 79.72%,
      #86ff8b 100%
    )
    left bottom no-repeat;
  background-size: 100% ${rem(18)};
`;

const StyledStatusOption = styled.div`
  position: relative;
  flex: 1 0 20%;
  hyphens: auto;
  padding-right: ${rem(6)};
  font-size: ${rem(8)};
  line-height: ${rem(14)};
  font-weight: 500;
  margin-bottom: ${rem(4)};

  ${mixins.MQ('medium')} {
    font-size: ${rem(10)};
    line-height: ${rem(18)};
  }

  :before {
    position: absolute;
    content: '';
    bottom: ${rem(-20)};
    left: ${rem(-3)};
    width: ${rem(3)};
    height: ${rem(13)};
    background: ${colors.white};
    border-radius: ${rem(2)};
  }
`;

const StatusLegend = (props: StatusLegendProps) => {
  const { statusOptions } = props;

  return (
    <StyledStatusLegend>
      <StyledStatusOption>{statusOptions['Level 5']}</StyledStatusOption>
      <StyledStatusOption>{statusOptions['Level 4']}</StyledStatusOption>
      <StyledStatusOption>{statusOptions['Level 3']}</StyledStatusOption>
      <StyledStatusOption>{statusOptions['Level 2']}</StyledStatusOption>
      <StyledStatusOption>{statusOptions['Level 1']}</StyledStatusOption>
    </StyledStatusLegend>
  );
};

export type StatusLegendProps = {
  statusOptions: Record<string, string>;
};

export default StatusLegend;
